export default {
  // Player
  'wow_player_dau': 'Player DAU',
  'wow_avg_player_dau': 'Avg.Player DAU',
  'wow_player_new': 'Player New',
  'wow_avg_player_new': 'Avg.Player New',
  'wow_player_return': 'Player Return',
  'wow_avg_player_return': 'Avg.Player Return',
  // Creator
  'wow_creator_dau': 'Creator DAU',
  'wow_avg_creator_dau': 'Avg.Creator DAU',
  'wow_creator_new': 'Creator New',
  'wow_avg_creator_new': 'Avg.Creator New',
  'wow_creator_return': 'Creator Return',
  'wow_avg_creator_return': 'Avg.Creator Return',

};